import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout/Layout'
// Core
import TypographyPage from '@/pages/Core/Typography/Typography'
import ColorsPage from '@/pages/Core/Colors/Colors'
import CoreGridPage from '@/pages/Core/Grid/Grid'
// Tables
import TablesBasicPage from '@/pages/Tables/Basic/Basic'
import TablesDynamicPage from '@/pages/Tables/Dynamic/Dynamic'
// Maps
import GoogleMapPage from '@/pages/Maps/Google/Google'
import VectorMapPage from '@/pages/Maps/Vector/Vector'
// Main
import VisitsPage from '@/pages/Visits/Visits'
import AnalyticsPage from '@/pages/Dashboard/Dashboard'
import WidgetsPage from '@/pages/Widgets/Widgets'
// Charts
import ChartsPage from '@/pages/Charts/Charts'
import FlotPage from '@/pages/Charts/Flot/Flot'
import MorrisPage from '@/pages/Charts/Morris/Morris'
import SparklinePage from '@/pages/Charts/Sparkline/Sparkline'
import EasyPiePage from '@/pages/Charts/EasyPie/EasyPie'
import ProfilePage from '@/pages/Profile/Profile'
import ProfilePageEdit from '@/pages/Profile/ProfileEdit'
// Profile
import PackagePage from '@/pages/Package/Package'
// Email
import EmailPage from '@/pages/Email/Email'
// Ecommerce
import ProductsPage from '@/pages/Ecommerce/ProductsGrid/ProductsGrid'
import ProductPage from '@/pages/Ecommerce/ProductPage/ProductPage'
// Grid
import GridPagePage from '@/pages/Grid/Grid'
// Forms
import FormElementsPage from '@/pages/Forms/Elements/Elements'
import FormValidationPage from '@/pages/Forms/Validation/Validation'
import FormWizardPage from '@/pages/Forms/Wizard/Wizard'
// Extra
import CalendarPage from '@/pages/Extra/Calendar/Calendar'
import InvoicePage from '@/pages/Extra/Invoice/Invoice'
import SearchPage from '@/pages/Extra/Search/Search'
import TimelinePage from '@/pages/Extra/Timeline/Timeline'
import GalleryPage from '@/pages/Extra/Gallery/Gallery'
import Login from '@/pages/Login/Login'
import Landing from '@/pages/Landing/Landing'
import Register from '@/pages/Register/Register'
import AuthLayout from '@/pages/AuthLayout/AuthLayout'
import NotFound from '@/pages/NotFound/NotFound.vue'
// Ui
import AlertsPage from '@/pages/Ui/Alerts/Alerts'
import BadgePage from '@/pages/Ui/Badge/Badge'
import ButtonsPage from '@/pages/Ui/Buttons/Buttons'
import CardPage from '@/pages/Ui/Card/Card'
import CarouselPage from '@/pages/Ui/Carousel/Carousel'
import IconsPage from '@/pages/Ui/Icons/Icons'
import JumbotronPage from '@/pages/Ui/Jumbotron/Jumbotron'
import ListGroupsPage from '@/pages/Ui/ListGroups/ListGroups'
import ModalPage from '@/pages/Ui/Modal/Modal'
import NavPage from '@/pages/Ui/Nav/Nav'
import NavbarPage from '@/pages/Ui/Navbar/Navbar'
import NotificationsPage from '@/pages/Ui/Notifications/Notifications'
import PopoversPage from '@/pages/Ui/Popovers/Popovers'
import ProgressPage from '@/pages/Ui/Progress/Progress'
import TabsPage from '@/pages/Ui/Tabs/Tabs'

// Dashboard pages
import Dashboard from '@/pages/Dashboard/Dashboard'
import ExploreMap from '@/pages/ExploreMap'
import TripEdit from '@/pages/TripEdit'
import Timeline from '@/pages/Timeline/Timeline'

Vue.use(Router)
import store from './store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated)
  {
    next()
    return
  }

  next()
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated)
  {
    var nextRoute = undefined
    if (store.getters.redirectAfterLogin)
    {
      nextRoute = store.getters.redirectAfterLogin
      store.dispatch('redirectAfterLogin', null)

    }

    next(nextRoute)
    return
  }

  store.dispatch('redirectAfterLogin', to.fullPath)

  next('/login')
}

let exploreMapMenu = {
  path:        '/explore',
  component:   Layout,
  name:        'Explore',
  redirect:    '/explore/map',
  props:       true,
  beforeEnter: ifAuthenticated,

  children: [
    {
      path:       'map',
      name:       'Explore Trips',
      components: {default: ExploreMap}
    },
    {
      path:       'map/:selectedUserId',
      name:       'Explore Trips',
      props:      true,
      components: {default: ExploreMap}
    },
    {
      path:       'my',
      name:       'My Trips',
      components: {default: ExploreMap}
    },
    {
      name:       'Explore Trip',
      path:       'trips/:selectedTripId',
      components: {default: ExploreMap},
      props:      true,
    },
    {
      name:       'Add Trip',
      path:       'trip/add',
      components: {default: ExploreMap},
      props:      true,
    },
    {
      path:       'trips/:selectedTripId/edit',
      name:       'TripEdit',
      components: {default: ExploreMap},
      props:      true,
    },
    {
      name:       'View Media',
      path:       'trips/:selectedTripId/media/:selectedMediaID',
      components: {default: ExploreMap},
      props:      true,
    },

    // {
    //   path:      '/',
    //   name : 'Landing',
    //   components: {default: Landing}
    // },

    // {path: '/profile', component: 'Profile', meta: {requiresAuth: true}},
    // {path: '/home/:selectedTripId', component: 'Home', props: true, meta: {requiresAuth: true}},
    //
    // {path: '/trip/add', name: 'TripAdd', component: 'Home', meta: {requiresAuth: true}},
    //
    // {path: '/photos', component: 'PhotosSelector', meta: {requiresAuth: true}},
    // {path: '/labels/:labelName', component: 'LabelViewer', props: true, meta: {requiresAuth: true}},
  ]
}

let authPages = {
  path:      '/',
  component: AuthLayout,
  name:      'Authentication',
  redirect:  '/landing',

  children: [
    {
      path:      '/landing',
      name:      'Welcome',
      component: Landing,
    },
    {
      path:        '/login',
      name:        'Login',
      component:   Login,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path:        '/register',
      name:        'Register',
      component:   Register,
      beforeEnter: ifNotAuthenticated,
    },
    // {
    //   path:      '/pricing',
    //   name:      'Pricing',
    //   component: Pricing
    // },
    // {
    //   path:      '/lock',
    //   name:      'Lock',
    //   component: Lock
    // }
  ]
}

export default new Router({
  mode:   'history',
  routes: [
    // {
    //   path:      '/',
    //   component: AuthLayout,
    //   name:      'Authentication',
    //   redirect:  '/landing',
    // },
    // {
    //   path:      '/login',
    //   name:      'Login',
    //   component: Login,
    // },
    // {
    //   path:      '/error',
    //   name:      'Error',
    //   component: ErrorPage,
    // },
    authPages,
    exploreMapMenu,
    {
      path:      '/',
      name:      'pages',
      component: Layout,
      props:     true,

      children: [
        // main pages
        {
          path:      'timeline',
          name:      'Timeline',
          component: Timeline,
        },
        // profile page
        {
          path:      'users/:selectedUserId',
          name:      'ProfilePage',
          component: ProfilePage,
          props:     true,
        },
        // profile page
        {
          path:      'users/:selectedUserId/edit',
          name:      'ProfilePageEdit',
          component: ProfilePageEdit,
          props:     true,
        },
      ]
    },
    {
      path:      '/app',
      name:      'Layout',
      component: Layout,
      children:  [
        // main pages
        {
          path:      'main/analytics',
          name:      'AnalyticsPage',
          component: AnalyticsPage,
        },
        {
          path:      'main/visits',
          name:      'VisitsPage',
          component: VisitsPage,
        },
        {
          path:      'main/widgets',
          name:      'WidgetsPage',
          component: WidgetsPage,
        },
        // package page
        {
          path:      'package',
          name:      'PackagePage',
          component: PackagePage,
        },

        // email page
        {
          path:      'email',
          name:      'EmailPage',
          component: EmailPage,
        },
        // ecommerce pages
        {
          path:      'ecommerce/products',
          name:      'ProductsPage',
          component: ProductsPage,
        },
        {
          path:      'ecommerce/product',
          name:      'ProductPage',
          component: ProductPage,
        },
        // core pages
        {
          path:      'core/typography',
          name:      'TypographyPage',
          component: TypographyPage,
        },
        {
          path:      'core/colors',
          name:      'ColorsPage',
          component: ColorsPage,
        },
        {
          path:      'core/grid',
          name:      'CoreGridPage',
          component: CoreGridPage,
        },
        // ui pages
        {
          path:      'ui/alerts',
          name:      'AlertsPage',
          component: AlertsPage,
        },
        {
          path:      'ui/badge',
          name:      'BadgePage',
          component: BadgePage,
        },
        {
          path:      'ui/buttons',
          name:      'ButtonsPage',
          component: ButtonsPage,
        },
        {
          path:      'ui/card',
          name:      'CardPage',
          component: CardPage,
        },
        {
          path:      'ui/carousel',
          name:      'CarouselPage',
          component: CarouselPage,
        },
        {
          path:      'ui/jumbotron',
          name:      'JumbotronPage',
          component: JumbotronPage,
        },
        {
          path:      'ui/icons',
          name:      'IconsPage',
          component: IconsPage,
        },
        {
          path:      'ui/list-groups',
          name:      'ListGroupsPage',
          component: ListGroupsPage,
        },
        {
          path:      'ui/modal',
          name:      'ModalPage',
          component: ModalPage,
        },
        {
          path:      'ui/nav',
          name:      'NavPage',
          component: NavPage,
        },
        {
          path:      'ui/navbar',
          name:      'NavbarPage',
          component: NavbarPage,
        },
        {
          path:      'ui/notifications',
          name:      'NotificationsPage',
          component: NotificationsPage,
        },
        {
          path:      'ui/popovers',
          name:      'PopoversPage',
          component: PopoversPage,
        },
        {
          path:      'ui/progress',
          name:      'ProgressPage',
          component: ProgressPage,
        },
        {
          path:      'ui/tabs',
          name:      'TabsPage',
          component: TabsPage,
        },
        // forms
        {
          path:      'forms/elements',
          name:      'FormElementsPage',
          component: FormElementsPage,
        },
        {
          path:      'forms/validation',
          name:      'FormValidationPage',
          component: FormValidationPage,
        },
        {
          path:      'forms/wizard',
          name:      'FormWizardPage',
          component: FormWizardPage,
        },
        // Charts
        {
          path:      'charts/overview',
          name:      'ChartsPage',
          component: ChartsPage,
        },
        {
          path:      'charts/flot',
          name:      'FlotPage',
          component: FlotPage,
        },
        {
          path:      'charts/morris',
          name:      'MorrisPage',
          component: MorrisPage,
        },
        {
          path:      'charts/sparkline',
          name:      'SparklinePage',
          component: SparklinePage,
        },
        {
          path:      'charts/easy-pie',
          name:      'EasyPiePage',
          component: EasyPiePage,
        },
        // grid page
        {
          path:      'grid',
          name:      'GridPage',
          component: GridPagePage,
        },
        // tables pages
        {
          path:      'tables/basic',
          name:      'TablesBasicPage',
          component: TablesBasicPage,
        },
        {
          path:      'tables/dynamic',
          name:      'TablesDynamicPage',
          component: TablesDynamicPage,
        },
        // maps pages
        {
          path:      'maps/google',
          name:      'GoogleMapPage',
          component: GoogleMapPage,
        },
        {
          path:      'maps/vector',
          name:      'VectorMapPage',
          component: VectorMapPage,
        },
        // extra pages
        {
          path:      'extra/calendar',
          name:      'CalendarPage',
          component: CalendarPage,
        },
        {
          path:      'extra/invoice',
          name:      'InvoicePage',
          component: InvoicePage,
        },
        {
          path:      'extra/search',
          name:      'SearchPage',
          component: SearchPage,
        },
        {
          path:      'extra/time-line',
          name:      'TimelinePage',
          component: TimelinePage,
        },
        {
          path:      'extra/gallery',
          name:      'GalleryPage',
          component: GalleryPage,
        },
      ],
    },
    {
      path: '*',

      component: AuthLayout,
      children:  [
        {
          path:       '',
          name:       'NotFound',
          components: {default: NotFound}
        },
      ]
    }
  ],
})
